import type { TypedShoppingCartItem } from "@Resources/js/laravel.d.ts"

export interface CartItem extends TypedShoppingCartItem {
  isDomainPurchase: () => boolean
  isDomainRenewal: () => boolean
  isRenewalService: () => boolean
  hasDiscount: () => boolean
}

export default function CartItemModel(data: TypedShoppingCartItem): CartItem {
  return {
    ...data,
    isDomainPurchase: () => data.type === "domain",
    isDomainRenewal: () => data.type === "domain_renew",
    isRenewalService: () => data.type === "domain_renewal_service",
    hasDiscount: () => (data.discountRate ?? 0) > 0,
  }
}
